import { useQuery } from '@tanstack/react-query';
import apiFetch from '../../utils/apiFetch';
import { authHeaders } from './helpers';
import type { ArchivedForm } from './types';

export function usePD7AForm(id: string | undefined) {
  return useQuery<ArchivedForm, Error>({
    queryKey: ['pd7a-form', id],
    enabled: Boolean(id),
    queryFn: async () => {
      const r = await apiFetch('/api/v1/payroll/taxes/archived-forms/' + id, {
        headers: authHeaders(),
      });
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json() as Promise<ArchivedForm>;
    },
    refetchOnWindowFocus: false,
  });
}